'use client'
import {
  __spreadValues
} from "./chunk-QB4ZOYYY.mjs";

// src/config.ts
var WbkCurrencyConfig = class {
  constructor() {
    this._config = null;
  }
  get config() {
    return this._config;
  }
  init(config) {
    this._config = config;
  }
  update(config) {
    this._config = __spreadValues(__spreadValues({}, this._config), config);
  }
};
var CurrencyConfig = new WbkCurrencyConfig();

export {
  CurrencyConfig
};
//# sourceMappingURL=chunk-437XYJZA.mjs.map